module.exports = fox._r("images/bg/home_slide_1_bg_1.jpg", __webpack_public_path__ + "images/bg/home_slide_1_bg_1.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg/home_slide_1_bg_1.jpg
// module id = 157
// module chunks = 5